import { breakpoints } from 'styles/mq'
import { useParallax } from 'components/parallax/useParallax'

import PhoneLeftSrc from './images/phone-left.png'
import PhoneLeftLandscapeSrc from './images/phone-left-landscape.png'
import { PhoneImg, PhoneLeftContainer } from './styled'

export const ParallaxPhoneLeft = () => {
  const { ref, translateY, isMobile } = useParallax({
    fromTo: ['-30rem', '30rem'],
  })

  return (
    <PhoneLeftContainer
      ref={ref}
      style={{
        translateY,
        translateX: isMobile ? 'none' : 'calc(-100vw + 100%)',
      }}
    >
      <picture>
        <source srcSet={PhoneLeftSrc} media={breakpoints.parallaxOn} />
        <PhoneImg src={PhoneLeftLandscapeSrc} alt="" aria-hidden />
      </picture>
    </PhoneLeftContainer>
  )
}
